export enum Hotkeys {
  ApplySelectedFilter = 'F1',
  ToggleCheckboxRow = ' ',
}
